export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';
export const SET_API_ENV = 'SET_API_ENV';

// MFA Actions for normal login
export const VERIFY_MFA_REQUEST = 'VERIFY_MFA_REQUEST';
export const VERIFY_MFA_SUCCESS = 'VERIFY_MFA_SUCCESS';
export const VERIFY_MFA_FAILURE = 'VERIFY_MFA_FAILURE';

export const RESET_MFA_REQUEST = 'RESET_MFA_REQUEST';
export const RESET_MFA_SUCCESS = 'RESET_MFA_SUCCESS';
export const RESET_MFA_FAILURE = 'RESET_MFA_FAILURE';

export const loginRequest = (email, password) => ({
    type: LOGIN_REQUEST,
    payload: { email, password },
});

export const verifyMfaRequest = (mfaCode, sessionId) => ({
    type: VERIFY_MFA_REQUEST,
    payload: { mfa_code: mfaCode, session_id: sessionId },
});

export const resetMfaRequest = (sessionId) => ({
    type: RESET_MFA_REQUEST,
    payload: { session_id: sessionId },
});

export const logout = () => ({
    type: LOGOUT,
});

export const setApiEnv = (env) => ({
    type: SET_API_ENV,
    payload: env,
});

export const clearAuthError = () => ({
    type: 'CLEAR_AUTH_ERROR',
});

